/* tslint:disable */
/* eslint-disable */
/**
 * Mr.Bilit Authentication api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { EzamLoginRequest } from '../model';
// @ts-ignore
import { LoginResponse } from '../model';
// @ts-ignore
import { ZarebinLoginRequest } from '../model';
/**
 * ThpApiApiTHPEzamLoginPost - axios parameter creator
 * 
 * @param {EzamLoginRequest} [ezamLoginRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ThpApiApiTHPEzamLoginPostAxiosParamCreator (ezamLoginRequest?: EzamLoginRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/THP/ezam/login`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(ezamLoginRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ThpApiApiTHPZareBinLoginPost - axios parameter creator
 * 
 * @summary Get token for Zarebin web view
 * @param {ZarebinLoginRequest} [zarebinLoginRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ThpApiApiTHPZareBinLoginPostAxiosParamCreator (zarebinLoginRequest?: ZarebinLoginRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/THP/ZareBinLogin`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(zarebinLoginRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiTHPEzamLoginPost operation in ThpApi.
 * @export
 * @interface ThpApiApiTHPEzamLoginPostRequest
 */
export interface ThpApiApiTHPEzamLoginPostRequest {
    /**
     * 
     * @type {EzamLoginRequest}
     * @memberof ThpApiApiTHPEzamLoginPost
     */
    readonly ezamLoginRequest?: EzamLoginRequest
}

/**
 * Request parameters for apiTHPZareBinLoginPost operation in ThpApi.
 * @export
 * @interface ThpApiApiTHPZareBinLoginPostRequest
 */
export interface ThpApiApiTHPZareBinLoginPostRequest {
    /**
     * 
     * @type {ZarebinLoginRequest}
     * @memberof ThpApiApiTHPZareBinLoginPost
     */
    readonly zarebinLoginRequest?: ZarebinLoginRequest
}

/**
* 
* @param {ThpApiApiTHPEzamLoginPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ThpApiApiTHPEzamLoginPost(requestParameters: ThpApiApiTHPEzamLoginPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ThpApiApiTHPEzamLoginPostAxiosParamCreator(requestParameters.ezamLoginRequest, options, configuration);
    const request: () => AxiosPromise<LoginResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Get token for Zarebin web view
* @param {ThpApiApiTHPZareBinLoginPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ThpApiApiTHPZareBinLoginPost(requestParameters: ThpApiApiTHPZareBinLoginPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ThpApiApiTHPZareBinLoginPostAxiosParamCreator(requestParameters.zarebinLoginRequest, options, configuration);
    const request: () => AxiosPromise<LoginResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
